<template>
  <div class="store-ranking-rule">
    <!-- 图片展示区 -->
    <img src="../../../assets/mall/store-ranking-rule-pic-1.png" alt="" width="1196" height="200">
    <p class="txt">如何提升品牌店排名</p>
    <img src="../../../assets/mall/store-ranking-rule-pic-2.png" alt="" width="852" height="893">
  </div>
</template>

<script>

export default {
  name: `StoreRankingRule`,
  data () {
    return {}
  },
  created () {}
}
</script>

<style lang="stylus">
.store-ranking-rule
  padding-top: 125px
  img
    display: block
    margin: 0 auto
  .txt
    text-style: 24px 500 #333 33px
    text-align: center
    margin: 50px 0 40px
</style>



// WEBPACK FOOTER //
// src/modules/mall/pages/StoreRankingRule.vue